export const isPrerender = () => {
  return navigator.userAgent === "ReactSnap";
};

export const initGA = () => {
  if (isPrerender()) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GTAG_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag("js", new Date());
  gtag("config", process.env.REACT_APP_GTAG_ID);

  console.log("✅ GA loaded");
};
